import { DateToLocal } from 'components/dates';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';

export function OcrDateRangeLayout(
    {
        loading = false,
        disabled = false,
        readonly = false,
        layout,
        ...props
    }
) {
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

    useEffect(() => {
        convertLayoutToDateRange();
    }, [layout]);

    function convertLayoutToDateRange() {
        if (layout?.table?.rows && layout.table.rows.length > 0) {
            const row = layout.table.rows[0];

            if (row.length > 1) {
                const startDate = row[0];
                const endDate = row[1];

                setDateRange({
                    startDate: startDate,
                    endDate: endDate
                });
            }
        }
    }

    return (
        <Fragment>
            <div className={classNames("form-field", { "hide-in-print": !readonly, "hidden": readonly })}>
                <span className={classNames({ "bp6-skeleton": loading })}><DateToLocal format='DD/MM/YYYY'>{dateRange.startDate}</DateToLocal> - {<DateToLocal format='DD/MM/YYYY'>{dateRange.endDate}</DateToLocal>}</span>
                    </div>
            <p className={classNames({ "show-in-print": !readonly, "visible": readonly, "bp6-skeleton": loading })}>{moment(dateRange.startDate, "MM/DD/YYYY", null).format("DD/MM/YYYY")} - {moment(dateRange.endDate, "MM/DD/YYYY", null).format("DD/MM/YYYY")}</p>
        </Fragment>
    );       
}

OcrDateRangeLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};
